<template>
  <div class="progression" :style="style">
    <a-textarea
      ref="text"
      v-if="strType === 'text'"
      :value="logData"
      :disabled='false'
      :auto-size="{ minRows, maxRows }"
    />
    <div ref="text" class="str" v-else v-html="logData"></div> 
  </div>
</template>

<script>
import handler from './logHandler'
export default {
  props: {
    style: {
      type: String,
      default: "width: 100%;"
    },
    minRows:{
      type:Number,
      default:23
    },
    maxRows:{
      type:Number,
      default:23
    },
    strType: {
      type: String,
      default: 'text'
    }
  },
  data() {
    return {
      logData:""
    }
  },
  methods: {
    addLog(logMsg, hideTime){
      this.logData = handler.addMsgToContent(logMsg,this.logData,this.strType, hideTime)
      const el =this.strType === 'text'?this.$refs.text.$el:this.$refs.text
      setTimeout(() => el.scrollTop = el.scrollHeight,10)
    },
    clear(){
      this.logData = ""
    }
  }
}
</script>

<style lang="less" scoped>
  .progression {
    > .ant-input {
      font-size: 14px;
      color: blue;
    }
    > .str {
      min-height: 500px;
      max-height: 520px;
      color: blue;
      overflow: auto;
      line-height: 1.63;
      a {
        color: red;
        font-size: 15px;
      }
    }
  }
</style>

